"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSelect = void 0;
var react_1 = __importDefault(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var selectTheme_1 = require("../selectTheme");
var selectUtil_1 = require("./selectUtil");
exports.FooterSelect = function (props) {
    var onChange = function (option) {
        if (option && selectUtil_1.isSelectOption(option)) {
            props.onSelectedChange(option.value);
        }
    };
    var positioning = props.menuPlacementTop
        ? { menuPosition: undefined, menuPlacement: "top" }
        : { menuPosition: "fixed", menuPlacement: "auto" };
    return props.selectedLabel && !props.disabled && react_1.default.createElement("div", null,
        react_1.default.createElement(react_select_1.default, __assign({ options: props.options, defaultValue: props.options.find(function (option) { return option.label === props.selectedLabel; }), value: props.options.find(function (option) { return option.label === props.selectedLabel; }), onChange: onChange, isDisabled: props.disabled, theme: selectTheme_1.SelectTheme, styles: selectUtil_1.customStyles }, positioning))) || null;
};
